export default __webpack_public_path__ + "static/media/Rabbit.59c023bf.jpg";